// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__37h9C","requiredAsterisk":"Info_requiredAsterisk__pJh27"};